import { useEffect, useState } from "react";
import axios from "axios";
import { IPGeolocation } from "../api/models";

const CACHE_KEY = "ip_geo_cache";
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

type CachedGeo = { data: IPGeolocation; fetchedAt: number };

const useIPGeolocation = (): IPGeolocation | null => {
  const [geo, setGeo] = useState<IPGeolocation | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (raw) {
          const cached: CachedGeo = JSON.parse(raw);
          if (Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
            setGeo(cached.data);
            return;
          }
        }
      } catch {
        // corrupted cache — treat as miss
      }

      try {
        const { data } = await axios.get("https://ipapi.co/json/");
        const geo: IPGeolocation = {
          ip: data.ip,
          city: data.city,
          region: data.region,
          region_code: data.region_code,
          country: data.country,
          country_name: data.country_name,
          country_code: data.country_code,
          continent_code: data.continent_code,
          latitude: data.latitude,
          longitude: data.longitude,
          timezone: data.timezone,
        };
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ data: geo, fetchedAt: Date.now() }),
        );
        setGeo(geo);
      } catch (error) {
        console.error("Error getting IP Geolocation:", error);
      }
    })();
  }, []);

  return geo;
};

export default useIPGeolocation;
